/* global angular, moment */
(function () {
  'use strict';

  /* @ngdoc object
   * @name utils.arrayEditor
   * @description
   *
   */
  angular
    .module('vcutils.listeditor', [
      'ui.router'
    ]);
}());
